module.exports = __webpack_public_path__ + "img/point_guide.b4c882d5.jpg";